<br>
<div class="clase-principal">
  <form [formGroup]="group" class="a-example-full-width-alterno-content-column">
    <div class="a-example-full-width-alterno-content-row">
      <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
        <div class="a-example-full-width-alterno-content-4">
          <p-floatlabel class="w-full" variant="on">
            <p-datepicker inputId="on_label" formControlName="desde" dateFormat="dd/mm/yy"
              [showClear]="true"></p-datepicker>
            <label for="on_label">Fecha Desde</label>
          </p-floatlabel>
        </div>
        <div class="a-example-full-width-alterno-content-4">
          <p-floatlabel class="w-full" variant="on">
            <p-datepicker inputId="on_label" formControlName="hasta" dateFormat="dd/mm/yy"
              [showClear]="true"></p-datepicker>
            <label for="on_label">
              <div style="width: 100px;">Fecha Hasta</div>
            </label>
          </p-floatlabel>
        </div>
        <div class="a-example-full-width-alterno-content-4">
          <p-button icon="pi pi-search" styleClass="p-button-info" (onClick)="consultarTarifarFlete()"
            [loading]="loading" [style]="{'margin-right': '8px'}"></p-button>
          <p-button icon="pi pi-file-export" styleClass="p-button-success" (onClick)="exportarExcel()"
            [loading]="loadingExcel"></p-button>
        </div>
      </div>
    </div>
  </form>

  <div class="example-full-width-alterno100">
    <app-datatable [dataTable]="datatable_tarifasfletes" [metadataTable]="metadatableTarifasFlete" [style]="estilos"
      [scrollHeight]="heightView+'px'" [filterGlobal]="true">
    </app-datatable>
  </div>

  <div class="a-example-full-width-alterno-content-column">
    <div class="a-example-full-width-alterno-content-row">
      <p-button *ngIf="esPopUp" icon="pi pi-times" styleClass="p-button-info" (onClick)="cerrar()"
        label=" Cerrar"></p-button>
    </div>
  </div>

</div>